// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bed831e8","455":"06c3171b","977":"8fecca28"}[chunkId] + ".chunk.js";
};